export enum PersonType {
  Client = 'client',
  Spouse = 'spouse',
}